import React from "react";
import PropTypes from "prop-types";
import {ajaxErrorHandler, defaultSuccess} from "../../../libs/utils";
import {createUser, getUser, updateUser} from "../../../services/api/users";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import EmployeeForm from "../../forms/EmployeeForm";
import {selectCompany} from "../../../redux/preferences/selectors";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import isEmail from "isemail";

class _CompanyEmployeesCreateUpdate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            user: undefined,
            isCreating: false,
            ajaxErrors: undefined
        };

        this._handleSubmit = this._handleSubmit.bind(this);
    }

    static propTypes = {
        match: PropTypes.object,
        company: PropTypes.object,
        history: PropTypes.object
    };

    UNSAFE_componentWillMount() {
        if (this.props.match.params.id) {
            getUser(this.props.match.params.id)
                .then(response => {
                    this.setState({
                        user: response,
                        loaded: true
                    });
                })
                .catch(ajaxErrorHandler);
        } else {
            this.setState({
                loaded: true
            });
        }
    }

    _validate(values) {
        let errors = {};

        if (!values.firstName || values.firstName === "") {
            errors.firstName = "required";
        }

        if (!values.lastName || values.lastName === "") {
            errors.lastName = "required";
        }

        if (!values.nationality || values.nationality === "") {
            errors.nationality = "required";
        }

        if (!values.dateofbirth || values.dateofbirth === "") {
            errors.dateofbirth = "required";
        }

        if (!values.nationalRegistryNumber || values.nationalRegistryNumber === "") {
            errors.nationalRegistryNumber = "required";
        }

        if (!values.vaccinated || values.vaccinated === "") {
            errors.vaccinated = "required";
        }

        if (!values.email || values.email === "") {
            errors.email = "required";
        }

        if (values.email && !isEmail.validate(values.email)) {
            errors.email = "Invalid email address";
        }

        return errors;
    }

    async _handleSubmit(values) {
        const {user} = this.state;

        this.setState({
            isCreating: true
        });

        const data = {
            firstName: values.firstName,
            lastName: values.lastName
        };

        if (!user) {
            data.companyIds = [this.props.company.id];
        }

        if (values.email && values.email !== "") {
            data.email = values.email;
        }

        if (values.gender && values.gender !== "") {
            data.gender = values.gender;
        }

        if (values.size && values.size !== "") {
            data.size = values.size;
        }

        if (values.telephone && values.telephone !== "") {
            data.telephone = values.telephone;
        }

        if (values.nationality && values.nationality !== "") {
            data.nationality = values.nationality;
        }

        if (values.vaccinated && values.vaccinated !== "" && values.vaccinated !== "nochange") {
            data.vaccinated = values.vaccinated === "yes";
        }

        if (values.nationalRegistryNumber && values.nationalRegistryNumber !== "" && values.nationalRegistryNumber.indexOf("XXXXXXXX") === -1) {
            data.nationalRegistryNumber = values.nationalRegistryNumber;
        }

        if (values.dateofbirth && values.dateofbirth !== "") {
            data.birthDate = values.dateofbirth.format("YYYY-MM-DD");
        }

        try {
            if (user) {
                await updateUser(user.id, data)
                    .then(response => {
                        defaultSuccess(
                            `${values.firstName} ${values.lastName} has been successfully updated.`
                        );
                        this.props.history.push("/company/employees");
                    });
            } else {
                await createUser(data)
                    .then(response => {
                        defaultSuccess(
                            `${values.firstName} ${values.lastName} has been successfully created.`
                        );
                        this.props.history.push("/company/employees");
                    });
            }
        } catch (error) {
            this.setState({
                isCreating: false,
            });
            ajaxErrorHandler(error);
        }
    }

    render() {
        const {loaded, user, ajaxErrors, isCreating} = this.state;

        const breadcrumbs = [
            {
                title: "Employees",
                to: "/company/employees"
            }
        ];

        if (loaded) {
            return [
                <AdminSubHeader
                    title={user ? "Update Employee" : "Create Employee"}
                    key="subheader"
                    breadcrumbs={breadcrumbs}
                />,
                <div className="m-content" key="content">
                    <EmployeeForm
                        onSubmit={this._handleSubmit}
                        formSubmitting={isCreating}
                        ajaxErrors={ajaxErrors}
                        user={user}
                        company
                        overwriteValidation={this._validate}
                    />
                </div>
            ];
        } else {
            return null;
        }
    }
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = function (state) {
    return {
        company: selectCompany(state)
    };
};

const CompanyEmployeesCreateUpdate = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(_CompanyEmployeesCreateUpdate)
);

export default CompanyEmployeesCreateUpdate;
